export default __webpack_public_path__ + "static/media/etherscan.f5d3b10b.svg";